module.exports = __webpack_public_path__ + "img/bumble_01.c8158619.png";